import React, { useState } from "react";
import { useOnboarding } from "../../contexts/OnboardingContext";
import { useAuth } from "../../contexts/AuthContext";
import axios from "axios";
import { API_URL } from "../../config";
import { INTERNAL_EMAILS } from "../../utils/internalEmails";

const Authority = () => {
    const { onboardingProfile, setOnboardingProfile, setError, error } = useOnboarding();
    const { user } = useAuth();
    const [isVerifying, setIsVerifying] = useState(false);
    const [isVerified, setIsVerified] = useState(!!onboardingProfile.dot_authorized);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setOnboardingProfile({ [name]: value });
        setIsVerified(false);
    };

    const handleVerify = async () => {
        if (!onboardingProfile.dot_number || onboardingProfile.dot_number.trim() === "") {
            setError("DOT Number is required");
            return;
        }

        setIsVerifying(true);
        setError("");

        try {
            const response = await axios.post(`${API_URL}/dot_authorization/check-dot`, {
                dot_number: onboardingProfile.dot_number,
            });

            // Allow verification if DOT is authorized OR user is internal email
            const isAuthorized = response.data.dot_authorized ||
                (user?.email && INTERNAL_EMAILS.includes(user.email));

            if (isAuthorized) {
                setOnboardingProfile({
                    dot_authorized: true,
                });
                setIsVerified(true);
            } else {
                setError("Unable to verify DOT Number. Please check and try again.");
                setIsVerified(false);
            }
        } catch (err) {
            console.error("Error verifying DOT:", err);
            setError("Failed to verify DOT Number. Please try again.");
            setIsVerified(false);
        } finally {
            setIsVerifying(false);
        }
    };

    return (
        <div className="space-y-6">
            <div className="space-y-4">
                <div>
                    <label htmlFor="dot_number" className="block text-sm font-medium text-gray-700 mb-2">
                        DOT Number <span className="text-red-500">*</span>
                    </label>
                    <div className="flex gap-2">
                        <input
                            type="text"
                            id="dot_number"
                            name="dot_number"
                            value={onboardingProfile.dot_number || ""}
                            onChange={handleChange}
                            className={`flex-1 px-4 py-2 border rounded-lg bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-tw-primary focus:border-transparent ${error && (error.includes("DOT") || error.includes("dot") || error.includes("verify"))
                                ? "border-red-300"
                                : "border-gray-300"
                                }`}
                            placeholder="1-8 Digits"
                            maxLength={8}
                        />
                        <button
                            type="button"
                            onClick={handleVerify}
                            disabled={isVerifying || !onboardingProfile.dot_number}
                            className="px-6 py-2 bg-gray-800 text-white rounded-lg font-medium hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            {isVerified ? "Change DOT" : isVerifying ? "Verifying..." : "Submit"}
                        </button>
                    </div>
                    {error && (error.includes("DOT") || error.includes("dot") || error.includes("verify")) ? (
                        <p className="mt-1 text-sm text-red-600">{error}</p>
                    ) : (
                        <p className="mt-1 text-sm text-gray-500">
                            Enter your DOT number and submit it.
                        </p>
                    )}
                </div>

                {isVerified && (
                    <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                        <p className="text-sm text-blue-800 font-medium">
                            ✓ DOT Number verified successfully!
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Authority;

